export function addNextYearAndSort(years: number[]): number[] {
  if (!years || years.length === 0) return [];

  const Year = Math.max(...years);
  const nextYear = Year + 1;

  const updatedYears = [...years, nextYear];
  return [...updatedYears].sort((a, b) => (b < a ? 1 : -1));
}